class ToTopButton {
    constructor(options = {}) {
        this.button = document.getElementById('to-top-button');
        this.scrollThreshold = options.scrollThreshold || 300;
        this.isScrolling = false;

        // Position tracking
        this.lastScrollY = 0;
        this.ticking = false;

        if (this.button) {
            this.init();
        }
    }

    init() {
        // Original-Position speichern
        const computedStyle = window.getComputedStyle(this.button);

        // Event Listeners
        window.addEventListener('scroll', this.handleScrollOptimized.bind(this), { passive: true });
        this.button.addEventListener('click', this.scrollToTop.bind(this));

        // Initial Check
        this.handleScroll();
    }

    onDockElementExitViewport() {
        // Element hat den Viewport verlassen
        this.resetPosition();
    }

    // Optimierte Scroll-Behandlung mit requestAnimationFrame
    handleScrollOptimized() {
        this.lastScrollY = window.scrollY;

        if (!this.ticking) {
            requestAnimationFrame(() => {
                this.handleScroll();
                this.ticking = false;
            });
            this.ticking = true;
        }
    }

    handleScroll() {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;

        if (scrollTop > this.scrollThreshold) {
            this.showButton();
        } else {
            this.hideButton();
        }
    }

    showButton() {
        if (!this.button.classList.contains('visible')) {
            this.button.classList.add('visible');
            this.button.setAttribute('tabindex', '0');
        }
    }

    hideButton() {
        if (this.button.classList.contains('visible')) {
            this.button.classList.remove('visible');
            this.button.setAttribute('tabindex', '-1');
        }
    }

    scrollToTop() {
        if (this.isScrolling) return;

        this.isScrolling = true;

        // Moderne Browser: scrollTo mit smooth behavior
        if ('scrollBehavior' in document.documentElement.style) {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });

            // Warten bis Scroll beendet ist
            this.waitForScrollEnd();
        } else {
            // Fallback für ältere Browser
            this.animateScrollFallback();
        }
    }

    waitForScrollEnd() {
        let lastScrollY = window.scrollY;
        let stableCount = 0;

        const checkScrollEnd = () => {
            const currentScrollY = window.scrollY;

            if (currentScrollY === 0) {
                this.isScrolling = false;
                this.focusTopOfPage();
                return;
            }

            if (Math.abs(currentScrollY - lastScrollY) < 1) {
                stableCount++;
                if (stableCount >= 3) {
                    this.isScrolling = false;
                    return;
                }
            } else {
                stableCount = 0;
            }

            lastScrollY = currentScrollY;
            requestAnimationFrame(checkScrollEnd);
        };

        requestAnimationFrame(checkScrollEnd);
    }

    animateScrollFallback() {
        const startPosition = window.scrollY;
        const startTime = performance.now();
        const duration = 1000;

        const easeInOutQuad = (t) => {
            return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        };

        const scroll = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const easedProgress = easeInOutQuad(progress);

            const currentPosition = startPosition - (startPosition * easedProgress);
            window.scrollTo(0, currentPosition);

            if (progress < 1) {
                requestAnimationFrame(scroll);
            } else {
                this.isScrolling = false;
                this.focusTopOfPage();
            }
        };

        requestAnimationFrame(scroll);
    }

    focusTopOfPage() {
        const focusTarget = document.querySelector('[href="#main"], #main, main, h1');
        if (focusTarget) {
            focusTarget.setAttribute('tabindex', '-1');
            focusTarget.focus();
        }
    }

    // Cleanup-Methode
    destroy() {
        if (this.inViewWatcher) {
            inView(this.dockElement).off('enter').off('exit');
        }

        window.removeEventListener('scroll', this.handleScrollOptimized);
        window.removeEventListener('resize', this.throttle(this.handleResize, 200));
    }

    throttle(func, limit) {
        let inThrottle;
        return function() {
            const args = arguments;
            const context = this;
            if (!inThrottle) {
                func.apply(context, args);
                inThrottle = true;
                setTimeout(() => inThrottle = false, limit);
            }
        };
    }
}

// Export für Module
export default ToTopButton;

// Initialisierung nach DOM-Load
document.addEventListener('DOMContentLoaded', () => {
    new ToTopButton();
});
